import React, { useState } from 'react';
import { Grid, TextField, Button, Typography, Box, Card, CardContent } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    msg: ''
  });

  const navigate = useNavigate(); // Initialize useNavigate

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('http://192.168.1.17:5000/api/contact', {
        ...formData,
        service: "random",
        msg: "random"
      });
      console.log('Form submitted successfully:', response.data);
      
      // Show alert message
      window.alert('Thank you for contacting us! Our team will reach out to you.');

      // Navigate to home route
      navigate('/home');
      
    } catch (error) {
      console.error('Error submitting the form:', error);
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Grid container spacing={4}>
        {/* Left side - Contact Form */}
        <Grid item xs={12} md={8}>
          <form onSubmit={handleSubmit}>
            <Card sx={{ padding: 4 }}>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Contact Us
                </Typography>
                <TextField
                  fullWidth
                  label="Name"
                  variant="outlined"
                  margin="normal"
                  required
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                <TextField
                  fullWidth
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  required
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                <TextField
                  fullWidth
                  label="Phone"
                  variant="outlined"
                  margin="normal"
                  required
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                <TextField
                  fullWidth
                  label="Message"
                  variant="outlined"
                  margin="normal"
                  multiline
                  rows={6}
                  required
                  name="msg"
                  value={formData.msg}
                  onChange={handleChange}
                  defaultValue="Hello {field:name} Please share your requirements in detail."
                />
                <Box sx={{ marginTop: 2 }}>
                  <ReCAPTCHA
                    sitekey="6LdAOy4qAAAAAJ25eMMxpmeXTxbAAyWLE9S2FC18"
                    onChange={(value) => console.log("Captcha value:", value)}
                  />
                </Box>
                <Box sx={{ marginTop: 2 }}>
                  <Button type="submit" variant="contained" color="primary" fullWidth>
                    Submit
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </form>
        </Grid>

        {/* Right side - Contact Details */}
        <Grid item xs={12} md={4}>
          <Card sx={{ padding: 4, backgroundColor: '#222', color: '#fff' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Bengaluru
              </Typography>
              <Typography variant="body2" gutterBottom>
                Tavarekere Main Rd
                <br />
                1st Stage, BTM Layout, Bengaluru
                <br />
                Infront of Mythree Mart Super Market
                <br />
                Karnataka, India 560029
              </Typography>

             
             

             
             

              <Typography variant="body2" gutterBottom sx={{ marginTop: 3 }}>
                Customer Care: (+91) 9995 955 596
                <br />
                Business Enquiry: (+91) 9995 722 255
                <br />
                WhatsApp: (+91) 7828 495 497
                <br />
                Email: khautomations.sales@gmail.com
                <br />
                Email: khautomations@gmail.com
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactUs;
